export interface EndTerminal {
    identifier: string | undefined;
    latitude: number;
    longitude: number;
}
